export const setAgentFilterSearchParam = ({
  searchParams,
  name,
  value,
  defaultValue,
}: {
  searchParams: URLSearchParams;
  name: string;
  value: string | undefined;
  defaultValue: string;
}) => {
  if (value === undefined) {
    return;
  }

  const normalizedValue = value.trim();

  if (!normalizedValue || normalizedValue === defaultValue) {
    searchParams.delete(name);
    return;
  }

  searchParams.set(name, normalizedValue);
};
